import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect } from 'react'

import { NotificationDrawer } from '../Components/NotificationDrawer'
import { NotificationStore } from '../Stores/NotificationStore'
import { LoadUnreadCountTask } from '../Tasks/LoadUnreadCountTask'

import type { PropsWithChildren } from 'react'

/**
 * Дзвіночок із кількістю непрочитаних.
 *
 * ⚠️ Компонент оголошено тут, поза хуком. Усередині хука він створювався б
 * заново на кожен рендер шапки — React вважав би його новим типом і
 * перемонтовував кнопку дзвіночка разом із підказкою.
 */
const NotificationBadge = observer(({ children }: PropsWithChildren) => {
    useEffect(() => {
        void LoadUnreadCountTask()
    }, [])

    return (
        <Badge count={NotificationStore.unreadCount} size="small" overflowCount={99} offset={[-4, 4]}>
            {children}
        </Badge>
    )
})

/** Публічне API контейнера для шапки: відкрити шухляду, дзвіночок, сама шухляда. */
export const useNotificationDrawer = () => {
    const openNotificationDrawer = useCallback(() => {
        NotificationStore.setIsDrawerOpen(true)
    }, [])

    return {
        openNotificationDrawer,
        NotificationBadge,
        NotificationDrawer,
    }
}
